import { action } from '@ember/object';
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class EmailInviteService extends Service {
  @tracked isOpen = false;

  @action
  toggleInviteModal(val = undefined) {
    if (val === undefined) this.isOpen = !this.isOpen;
    else this.isOpen = val;
  }
}
